// Field bisa nyembunyiin diri lewat visibleWhen(form).
export function visibleFields(fields, form) {
  const state = form || {};
  return fields.filter((field) => typeof field.visibleWhen !== 'function' || field.visibleWhen(state));
}

export function splitSet(value) {
  if (Array.isArray(value)) return value.slice();
  if (typeof value !== 'string') return [];
  return value.split(',').map((part) => part.trim()).filter(Boolean);
}

export function joinSet(value) {
  if (Array.isArray(value)) return value.join(',');
  return typeof value === 'string' ? value : '';
}

export function buildPayload(fields, form, pkField) {
  const payload = {};
  visibleFields(fields, form).forEach((field) => {
    if (field.key === pkField || field.virtual) return;

    if (field.type === 'checkbox-group') {
      payload[field.key] = joinSet(form[field.key]);
      return;
    }

    const value = form[field.key];
    if (value === '' || value === null || value === undefined) return;
    payload[field.key] = field.type === 'number' ? Number(value) : value;
  });
  return payload;
}
